import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DualListComponent } from './dual-list/dual-list.component';
import { SpecialCharacterDirective } from './specialCharacter.directive';
import { CustomPipe } from './pipes/filter.pipe';
import { LoadingModule } from './loading/loading/loading.module';
import { PaymentSuccessComponent } from './payment-results/payment-success/payment-success.component';
import { PaymentFailedComponent } from './payment-results/payment-failed/payment-failed.component';
import { CustomCurrencyPipe } from './pipes/custompipe';
import { CustomCursorComponent } from './components/custom-cursor/custom-cursor.component';

@NgModule({
    declarations: [
        DualListComponent,
        SpecialCharacterDirective,
        CustomPipe,
        PaymentSuccessComponent,
        PaymentFailedComponent,
        CustomCurrencyPipe,
        CustomCursorComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatButtonModule,
        LoadingModule,
    
       
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DualListComponent,
        SpecialCharacterDirective,
        CustomPipe,
        LoadingModule,
        CustomCurrencyPipe,
        CustomCursorComponent

        // SearchFilterPipe,
        
    ],
})
export class SharedModule {}
